var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.369,2.147a9.776,9.776,0,0,1,4.194,8.012A9.923,9.923,0,0,1,10.583,20,9.945,9.945,0,0,1,.562,10.175,9.8,9.8,0,0,1,4.748,2.151a.98.98,0,0,1,1.411.306L6.8,3.571A.942.942,0,0,1,6.53,4.8a6.6,6.6,0,0,0-2.742,5.353,6.716,6.716,0,0,0,6.774,6.671,6.719,6.719,0,0,0,6.774-6.71A6.635,6.635,0,0,0,14.591,4.8a.937.937,0,0,1-.262-1.226l.637-1.115a.975.975,0,0,1,1.4-.31Zm-4.194,8.329V.952A.958.958,0,0,0,11.208,0H9.917A.958.958,0,0,0,8.95.952v9.524a.958.958,0,0,0,.968.952h1.29A.958.958,0,0,0,12.175,10.476Z",
    transform: "translate(-0.562)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.26bc6f5481fb1eca08756630162f9841.svg";
export { ForwardRef as ReactComponent };